// extracted by mini-css-extract-plugin
module.exports = {"colorText":"DeviceOnlineState_colorText__2nfB9","textWithTime":"DeviceOnlineState_textWithTime__25KTu","timestampText":"DeviceOnlineState_timestampText__mFdMi"};